import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    ClipPayment,
    CreateClipPaymentInput,
    UpdateClipPaymentInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class ClipPaymentService {
    private amplifyClient = generateClient();

    constructor() {}

    async listClipPayments(): Promise<ClipPayment[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listClipPayments
                })
            ).data.listClipPayments.items;
            if (data) return data as ClipPayment[];
        } catch (error) {
            console.error('Error finding LogsPUsers:', error);
            return null;
        }
    }
    async clipPaymentsByPremiumOrder(orderId: string): Promise<ClipPayment[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ClipPaymentsByPremiumOrder,
                    variables: {
                        orderId
                    }
                })
            ).data.ClipPaymentsByPremiumOrder.items;
            if (data) return data as ClipPayment[];
        } catch (error) {
            console.error('Error finding ClipPayment:', error);
            return null;
        }
    }

    async clipPaymentsByClient(clientId: string): Promise<ClipPayment[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ClipPaymentsByClient,
                    variables: {
                        clientId
                    }
                })
            ).data.ClipPaymentsByClient.items;
            if (data) return data as ClipPayment[];
        } catch (error) {
            console.error('Error finding ClipPayment:', error);
            return null;
        }
    }
    async clipPaymentsByUser(userId: string): Promise<ClipPayment[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ClipPaymentsByUser,
                    variables: {
                        userId
                    }
                })
            ).data.ClipPaymentsByUser.items;
            if (data) return data as ClipPayment[];
        } catch (error) {
            console.error('Error finding ClipPayment:', error);
            return null;
        }
    }

    async createClipPayment(
        input: CreateClipPaymentInput
    ): Promise<ClipPayment> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.createClipPayment,
                    variables: {
                        input
                    }
                })
            ).data.createClipPayment;
            if (client) return client as ClipPayment;
        } catch (error) {
            console.error('Error creating ClipPayment:', error);
            return null;
        }
    }
    async updateClipPayment(
        input: UpdateClipPaymentInput
    ): Promise<ClipPayment> {
        try {
            const client = (
                await this.amplifyClient.graphql({
                    query: mutations.updateClipPayment,
                    variables: {
                        input
                    }
                })
            ).data.updateClipPayment;
            if (client) return client as ClipPayment;
        } catch (error) {
            console.error('Error creating ClipPayment:', error);
            return null;
        }
    }
}
